<script>
</script>

<div>
    <h1>
      La <span>Formidable</span> <br> aventure d’<span>Orsay</span>
    </h1>

    <img src="./images/avatar/smile.png" alt="">
</div>

<style>
    div {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        position: relative;
    }
    h1 {
        font-size: 3.25rem;
        font-weight: 500;
    }
    span {
      color: #F73132;
      font-weight: 700;
    }

    img {
      width: 160px;
      position: absolute;
      top: -50px;
      right: -100px;
    }
</style>